import { createListenerMiddleware } from '@reduxjs/toolkit';

import { appListeners } from './app';
import { authCredentialsListeners } from './authCredentials';
import { kybListeners } from './kyb';

export const listenerMiddleware = createListenerMiddleware();

appListeners(listenerMiddleware);
kybListeners(listenerMiddleware);
authCredentialsListeners(listenerMiddleware);
